import { UserMessage } from 'app/types-shared';

export const getUserMessage = (message: string | UserMessage[]) => Array.isArray(message)
  ? message.map(m => m.message).join('\n') : message;
